function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(3 2)",
  fillRule: "nonzero",
  fill: "none"
}, React.createElement("path", {
  d: "M14 2.625v16.5C14 20.971 15.214 22 16.5 22c1.19 0 2.5-.875 2.5-2.875V2.75C19 1.058 17.81 0 16.5 0S14 1.166 14 2.625z",
  fill: "#F9AB00"
}), React.createElement("path", {
  d: "M7 11.505v7.752C7 21.018 8.214 22 9.5 22c1.19 0 2.5-.835 2.5-2.743v-7.633C12 10.009 10.81 9 9.5 9S7 10.113 7 11.505z",
  fill: "#E37400"
}), React.createElement("circle", {
  fill: "#E37400",
  cx: 2.5,
  cy: 19.5,
  r: 2.5
}));

var SvgGoogleAnalytics = function SvgGoogleAnalytics(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 26 26"
  }, props), _ref);
};

export default SvgGoogleAnalytics;